import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_QuestionReply/Load',
      params,
    });
  },
  GetStdQue(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_QuestionReply/GetStdQue',
      params,
    });
  },
};
